import React from "react";

import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import DashboardLayout from "../../dashboard/DashboardLayout";
import { SettingsContextProvider } from "../../../provider/settings/settings/SettingsContextProvider";
import SettingsContent from "./SettingsContent";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import { SettingsPersonalProfileContextProvider } from "../../../provider/settings/manage_personal_profile/SettingsPersonalProfileContextProvider";

const SettingsScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <DashboardLayout title={AppTranslation.text("settings")} navIndex={4}>
      <MainBodyContainer className="h-100">
        <SettingsContextProvider>
          <SettingsPersonalProfileContextProvider>
          <SettingsContent type={type} />
          </SettingsPersonalProfileContextProvider>
        </SettingsContextProvider>
      </MainBodyContainer>
    </DashboardLayout>
  );
};

export default SettingsScreen;
export const routeName: string = "/settings";
